import React, { type FC, type PropsWithChildren } from 'react';

import { Redirect as InternalRedirect } from '@reach/router';
import { withPrefix } from 'gatsby';
import { getInternalLink, isBrowser } from '@lucid/utils';
import { usePathPrefix } from '@lucid/hooks';

export interface RedirectProps {
  /** Will pass query params with the redirect */
  shouldPassQueryParams?: boolean;
  /** The URL to redirect to */
  to: string;
  /** The site url for the domain the redirect is used on, not necessarily the redirect domain. */
  siteDomain: string;
  /** A list of domains to block from */
  blocklist?: string[];
}

const Redirect: FC<PropsWithChildren<RedirectProps>> = ({ to, shouldPassQueryParams, siteDomain, blocklist }) => {
  const link = getInternalLink({ link: to, siteDomain, blocklist, pathPrefix: usePathPrefix() });
  let searchParams = '';

  if (shouldPassQueryParams) {
    searchParams = window.location.search;
  }

  if (link.isInternal) {
    return <InternalRedirect noThrow to={withPrefix(`${link.url}${searchParams}`)} />;
  }

  if (to && isBrowser()) {
    window.location.replace(`${to}${searchParams}`);
  }

  return <></>;
};

export default Redirect;
